var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignStudioLogoForStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18041 38.6286L18.1129 26.6961M33.1392 21.3899L29.5673 32.1055C29.5103 32.2773 29.4127 32.4327 29.2828 32.5587C29.1529 32.6847 28.9945 32.7775 28.821 32.8293L6.92478 39.3374C6.72751 39.396 6.51796 39.3993 6.31891 39.3471C6.11987 39.2948 5.93897 39.189 5.79589 39.0411C5.65282 38.8932 5.55306 38.7089 5.50746 38.5082C5.46186 38.3075 5.47218 38.0982 5.53728 37.903L12.6473 16.5768C12.6982 16.4236 12.7815 16.2833 12.8915 16.1652C13.0015 16.0471 13.1357 15.9541 13.2848 15.8924L23.3854 11.7336C23.5908 11.6488 23.8166 11.6267 24.0345 11.6701C24.2524 11.7135 24.4526 11.8204 24.6098 11.9774L32.8673 20.2386C33.015 20.3864 33.1187 20.5723 33.1667 20.7756C33.2148 20.979 33.2052 21.1917 33.1392 21.3899Z",
    stroke: "url(#paint0_linear_5410_2196)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3609 20.7314L38.6634 15.427C39.3664 14.7238 39.7613 13.7701 39.7613 12.7758C39.7613 11.7814 39.3664 10.8277 38.6634 10.1245L34.6884 6.14576C34.3401 5.79738 33.9267 5.52102 33.4716 5.33247C33.0165 5.14392 32.5288 5.04688 32.0362 5.04688C31.5436 5.04688 31.0558 5.14392 30.6008 5.33247C30.1457 5.52102 29.7322 5.79738 29.384 6.14576L24.0815 11.4501M22.0902 22.7189C21.829 22.4578 21.5189 22.2506 21.1776 22.1094C20.8363 21.9681 20.4705 21.8954 20.1011 21.8955C19.7318 21.8956 19.366 21.9684 19.0248 22.1099C18.6836 22.2513 18.3736 22.4586 18.1124 22.7198C17.8513 22.9811 17.6442 23.2912 17.5029 23.6325C17.3616 23.9738 17.289 24.3396 17.2891 24.7089C17.2891 25.0783 17.362 25.444 17.5034 25.7853C17.6449 26.1265 17.8521 26.4365 18.1134 26.6976C18.641 27.225 19.3565 27.5212 20.1025 27.521C20.8484 27.5208 21.5638 27.2243 22.0912 26.6967C22.6185 26.1691 22.9147 25.4536 22.9145 24.7076C22.9144 23.9616 22.6179 23.2463 22.0902 22.7189Z",
    stroke: "url(#paint1_linear_5410_2196)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5410_2196",
    x1: 19.3382,
    y1: 11.6484,
    x2: 19.3382,
    y2: 39.3839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62C710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CBA10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5410_2196",
    x1: 28.5252,
    y1: 5.04687,
    x2: 28.5252,
    y2: 27.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62C710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CBA10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignStudioLogoForStripe);
export default __webpack_public_path__ + "static/media/design_studio_logo_for_stripe.6c496d44967d12dcbbc88764f5ef6a5f.svg";
export { ForwardRef as ReactComponent };